import { render } from "./knowledgebase.vue?vue&type=template&id=a9ed0756"
import script from "./knowledgebase.vue?vue&type=script&lang=js"
export * from "./knowledgebase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__